import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ConnectionService } from '@nomoh-monorepo/data-access-shared-connection';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'lib-feature-s-pwa-online-status',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './feature-s-pwa-online-status.component.html',
  styleUrls: ['./feature-s-pwa-online-status.component.scss'],
})
export class FeatureSPwaOnlineStatusComponent {
  pwaOnlineStatusService = inject(ConnectionService);

  statusClass = computed(() =>
    this.pwaOnlineStatusService.$isOnline() ? 'online' : 'offline'
  );

  statusIcon = computed(() =>
    this.pwaOnlineStatusService.$isOnline() ? '' : 'pi pi-globe'
  );

  statusText = computed(() =>
    this.pwaOnlineStatusService.$isOnline() ? '' : 'Offline'
  );
}
